<template>
  <div class="vv-invalid">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'VvInvalid'
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.vv-invalid {
  border: 3px solid $wrong-color;
  border-radius: 8px;
  padding: 15px;
  background-color: white;
  box-shadow: 0 14px 28px 5px rgba(220, 220, 220, 0.5);
}
</style>
